// extracted by mini-css-extract-plugin
module.exports = {"hidden":"projectviewer-module--hidden--3xWL1","active":"projectviewer-module--active--CQfh3","centeredmenu":"projectviewer-module--centeredmenu--DsyFh"};